import Typography from "@mui/material/Typography";
import MPENetworks from "singularitynet-platform-contracts/networks/MultiPartyEscrow";
import { SNETTextfield, SNETButton } from "shared/dist/components";
import { useState } from "react";
import classes from "./AdvancedFields.module.css";
import clsx from "clsx";

const AdvancedFields = ({ isFreezedByActivatedHaas }) => {
    const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);

    const ToggleVisibility = () => {
        return (
            <div>
                <SNETButton
                    children={showAdvancedSettings ? "hide MPE info" : "show MPE info"}
                    variant="outlined"
                    color="primary"
                    onClick={() => setShowAdvancedSettings(!showAdvancedSettings)}
                    disabled={isFreezedByActivatedHaas}
                />
            </div>
        );
    };

    if (!showAdvancedSettings) {
        return <ToggleVisibility />;
    }
    return (
        <div
            className={clsx(
                classes.advFilesContainer,
                isFreezedByActivatedHaas && classes.disabled
            )}
        >
            <Typography variant="h6" className={classes.header}>
                Advanced Fields
            </Typography>
            <p className={classes.description}>
                These fields are for refrence only and do not need to be changed
            </p>
            <SNETTextfield
                name="mpeAddress"
                value={
                    MPENetworks[process.env.REACT_APP_ETH_NETWORK][
                        process.env.REACT_APP_TOKEN_NAME
                    ][process.env.REACT_APP_STAND].address
                }
                label="MPE Address"
                description={
                    <>
                        The ethereum address of the MultiParty Escrow contract on the Ethereum
                        mainnet. Details &nbsp;
                        <a
                            href="https://dev.singularitynet.io/docs/products/DecentralizedAIPlatform/CoreConcepts/SmartContracts/mpe/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            here
                        </a>
                    </>
                }
                disabled
                disabledAll={isFreezedByActivatedHaas}
            />
            <ToggleVisibility />
        </div>
    );
};

export default AdvancedFields;
